
// Pass in the objects to merge as arguments.
// For a deep extend, set the first argument to `true`.
// export function deepCopy (target, donor) {
//     const extended = target || {};
//
//     for (const prop in donor) {
//         if (Object.prototype.hasOwnProperty.call(donor, prop)) {
//             // If deep merge and property is an object, merge properties
//             if (Object.prototype.toString.call(donor[prop]) === '[object Object]') {
//                 extended[prop] = deepCopy(extended[prop], donor[prop]);
//             } else {
//                 extended[prop] = donor[prop];
//             }
//
//         }
//     }
//     return extended;
// }
// noinspection OverlyComplexFunctionJS,FunctionWithMultipleLoopsJS

export function deepCopy(...args) {
    let options, name, src, copy, copyIsArray, clone,
        target = args[0] || {},
        i = 1,
        deep = false;
        const length = args.length;
    // Handle a deep copy situation
    if ( typeof target === "boolean" ) {
        deep = target;
        target = args[1] || {};
        // skip the boolean and the target
        i = 2;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if ( typeof target !== "object" && typeof (target)!=="function") {
        target = {};
    }

    for ( ; i < length; i++ ) {
        // Only deal with non-null/undefined values
        if ( (options = args[ i ]) != null ) {
            // Extend the base object
            for ( name in options ) {
                src = target[ name ];
                copy = options[ name ];

                // Prevent never-ending loop
                if ( target === copy ) {
                    continue;
                }

                // Recurse if we're merging plain objects or arrays
                if ( deep && copy && ( isPlainObject(copy) || (copyIsArray =  Array.isArray(copy)) ) ) {
                    if ( copyIsArray ) {
                        copyIsArray = false;
                        clone = src && Array.isArray(src) ? src : [];

                    } else {
                        clone = src && isPlainObject(src) ? src : {};
                    }

                    // Never move original objects, clone them
                    target[ name ] = deepCopy( deep, clone, copy );

                    // Don't bring in undefined values
                } else if ( copy !== undefined ) {
                    target[ name ] = copy;
                }
            }
        }
    }

    // Return the modified object
    return target;
}

const o = {},
    toString = o.toString,
    oprop = o.isPrototypeOf && "isPrototypeOf" || "hasOwnProperty";


const hasOwn = o.hasOwnProperty || function( prop ) {
    if ( prop in (this as any)) {
        const value = this[prop];

        if ( !( delete this[ prop ] ) ) {
            return true;
        }

        if ( !(prop in this) || this[prop] !== value ) {
            this[ prop ] = value;
            return true;
        }
    }

    return false;
};

const isPlainObject = function( obj ) {
    // Must be an Object.
    if ( !obj || toString.call(obj) !== "[object Object]" || !(oprop in obj) || hasOwn.call(obj, oprop) ) {
        return false;
    }

    // If constructor is not own, then it must be Object.
    if ( obj.constructor && !hasOwn.call( obj, "constructor" ) &&
        obj.constructor.prototype && !hasOwn.call( obj.constructor.prototype, oprop ) ) {
        return false;
    }

    // Also we have to check that all enumerable properties are own.

    // Own properties are enumerated firstly,
    // so if last one is own, then all others are own too.

    // Get last enumerable property.
    let prop
    for (prop in obj ) {}

    return prop === undefined || hasOwn.call( obj, prop );
}
